import { useLocalStorage } from '@uidotdev/usehooks';
import { useLocation, Outlet, useNavigate } from 'react-router';
import { LoginResponseData } from '@EHSNavigator/backend';
import InfoContent from './components/InfoContent';
import WarningIcon from './assets/icons/warning-icon.svg?react';

const PermissionRoute = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [userInfo] = useLocalStorage<LoginResponseData | null>('userInfo', null);
  const { user: { role: { permissions } } } = userInfo as LoginResponseData;

  const hasPermission = permissions?.some((node) => {
    const permissionPath = node?.name;
    const currentPath = location?.pathname;
    if (!permissionPath || !currentPath) return false;
    if (permissionPath === currentPath) return true;
    if (permissionPath.includes(':id')) {
      const basePath = permissionPath.replace(':id', '');
      return (
        currentPath.startsWith(basePath) &&
        currentPath.length > basePath.length &&
        /^[a-fA-F0-9-]{36}$/.test(currentPath.slice(basePath.length))
      );
    }
    if (currentPath.startsWith(permissionPath)) {
      const nextChar = currentPath[permissionPath.length];
      return !nextChar || nextChar === '/' || nextChar === '?';
    }
    return false;
  });

  return hasPermission ? (
    <Outlet />
  ) : (
    <div className="flex w-full flex-1 flex-col items-center justify-center">
      <InfoContent
        icon={<WarningIcon className="h-100 w-100 lg:h-150 lg:w-150" />}
        title="Access denied"
        description="Please contact your administrator to get access to this page."
        buttonLabel="Go to Dashboard"
        warn
        otherClasses=""
        handleClick={() => navigate('/dashboard')}
      />
    </div>
  );
};
export default PermissionRoute;
